module.exports = __webpack_public_path__ + "img/sesame.950976bd.svg";